import React, { useEffect, useState, useMemo, useCallback } from "react";
import { ReactComponent as Profile } from "../../../assets/svgs/profile.svg";
import { ReactComponent as User } from "../../../assets/svgs/user.svg";
import { ReactComponent as Logout } from "../../../assets/svgs/logout.svg";
import { Dropdown } from "antd";
import { Link, useLocation } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import { logout } from "../../../utils/api/logout";
import toast from "react-hot-toast";
import { removeAuthToken, removeAuthUser } from "../../../utils/token";

const HeaderDropdown = () => {
  const { authUser, setAuthUser } = useAuthContext();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const currentLocation = location.pathname;
  useEffect(() => {
    if (dropdownOpen) {
      if (currentLocation === "/")
        document.body.classList.add("overflow-hidden", "mr-[13px]");
      else document.body.classList.add("overflow-hidden");
    }
    return () => {
      if (currentLocation === "/")
        document.body.classList.remove("overflow-hidden", "mr-[13px]");
      else document.body.classList.remove("overflow-hidden");
    };
  }, [dropdownOpen, currentLocation]);

  const logOutHandler = useCallback(async () => {
    try {
      setLoading(true);
      await logout(setAuthUser);
      removeAuthToken();
      removeAuthUser();
      setAuthUser(null);
    } catch (error) {
      if (error.status !== 401) {
        toast.error(error.message);
      }
    } finally {
      setLoading(false);
      setDropdownOpen(false);
    }
  }, [setAuthUser]);

  const items = useMemo(
    () => [
      {
        key: "1",
        label: (
          <Link className="font-spaceGrotesk" to="#">
            <div className="flex border-b-[2px] py-2 px-4">
              <Profile className="w-8" />
              <div className="ml-2">
                <h4 className=" capitalize text-xs font-medium tracking-wider">
                  {authUser.name}
                </h4>
                <h4 className=" capitalize text-[8px] text-gray-400">Admin</h4>
              </div>
            </div>
          </Link>
        ),
      },

      {
        key: "2",
        label: (
          <Link className=" font-spaceGrotesk border-b-2 border-black" to="/user-profile">
            <div className="flex pl-10 py-2">
              <User className="w-3" />
              <p className="text-xs font-medium pl-2">My Profile</p>
            </div>
          </Link>
        ),
      },

      {
        key: "3",
        label: (
          <button onClick={logOutHandler} className=" font-spaceGrotesk">
            <div className="flex pl-10 py-2">
              <Logout className="w-3" />
              <p className="text-xs font-medium pl-2">
                {loading ? "loading..." : "Logout"}
              </p>
            </div>
          </button>
        ),
      },
    ],
    [loading, logOutHandler, authUser.name]
  );

  return (
    <>
      {dropdownOpen && (
        <div
          className="fixed top-0 left-0 w-screen h-screen z-10 overlay"
          style={{ backgroundColor: "rgb(0,0,0, 0.5)" }}
        />
      )}
      <Dropdown
        onOpenChange={(e) => setDropdownOpen(e)}
        menu={{
          items,
        }}
        trigger={"click"}
        overlayClassName="w-44 header-dropdown"
      >
        <Profile className="w-10 bg-[#D9D9D9] rounded-full border-2 border-[#D9D9D9] cursor-pointer" />
      </Dropdown>
    </>
  );
};

export default HeaderDropdown;
